import * as React from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';
import ExtensionIcon from '@mui/icons-material/Extension';
import { useNavigate, useLocation } from "react-router-dom";
import { Stack, TextField, Tooltip } from '@mui/material';
import {
    BtnBold,
    BtnBulletList,
    BtnClearFormatting,
    BtnItalic,
    BtnLink,
    BtnNumberedList,
    BtnRedo,
    BtnStrikeThrough,
    BtnStyles,
    BtnUnderline,

    BtnUndo,
    HtmlButton,
    Separator,
    createButton,

    Editor,
    EditorProvider,
    Toolbar
} from 'react-simple-wysiwyg';
import Service from '../../../util/Service';
import ImgCompDialog from '../../util/ImgCompDialog';
import ExtensionCompDialog from '../../util/ExtensionCompDialog';
import VeryEditorJS from '../portal/editorJs/VeryEditorJS';
import VeryEditor2 from '../../common/EditorVery/VeryEditor2';

const BtnAlignCenter = createButton('Align center', '≡', 'justifyCenter');

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function EditarPaginaHtml(props) {
    const { open, setOpen, pagina, doAction } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [html, setHtml] = React.useState('');
    const [codigo, setCodigo] = React.useState();
    const [tipo, setTipo] = React.useState('');
    const [titulo, setTitulo]= React.useState();
    const [openImg, setOpenImg] = React.useState(false);
    const [openExt, setOpenExt]= React.useState(false);
    const ref = React.useRef();

    React.useEffect(()=>{
        if( pagina){
            if( pagina.codigo){
                setCodigo(pagina.codigo);
                setTipo('codigo')
            }else{
                setHtml( pagina.pagina);
                setTipo('pagina')
            } 
            setTitulo(pagina.titulo);
        }
    },[pagina])

    function handleOnChange(e) {
        setHtml(e.target.value);
    }
    const handleSalva = () => {
        if( !ref){
            alert('Perdeu a referencia');
        }
        let dado = { ...pagina }

        if (pagina) {
            dado.id = pagina.id;
            dado.nome = pagina.nome;
        } else {
            const path = location.pathname.split("/").slice(1);
            if (!path) return false;
            const p = path[path.length - 1];
            dado.nome = p;
        }
        dado.titulo = titulo
        const h = ref.current.getHtml();
        dado.codigo = codigo;
        if( codigo ){
            dado.codigo = codigo;
            delete dado.pagina;
        }else if( h && h.length > 0 ){
            dado.pagina = h;
            setHtml(h);
            delete dado.codigo;
        }
        
                
        Service.POST("/api/security/paginaHtml", dado).then(r => {
            
            // setOpen(false);
            if (doAction) doAction(r);
        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
            localStorage.setItem("localStorage", location.pathname);
            navigate("/login");
        })
    };
    function montaTitulo() {
        let txt = "Editar Pagina";
        if (pagina) {
            txt += ' ' + pagina.nome;
        } else {
            const path = location.pathname.split("/").slice(1);
            const p = path[path.length - 1];
            txt += " " + p
        }
        return txt;
    }
    
    const BtnAddComp = (e) => {
        const handleAddExt=()=>{            
            setOpenExt(true)
        }
        return (
            <Tooltip title="Extensão">
                <IconButton aria-label="extensao" onClick={handleAddExt} size="small">
                    <ExtensionIcon />
                </IconButton>
            </Tooltip>
        )
    }
    const BtnAddImg = (e) => {
        const handleAddImg = (e) => {
            setOpenImg(true)
        }
        return (
            <Tooltip title="Anexo">
            <IconButton aria-label="anexo" onClick={handleAddImg} size="small">
                <ImageIcon />
            </IconButton>
            </Tooltip>
        )
    }
    function isYoutube(url){
        console.log( typeof url );
        if( typeof url === 'object') return false;
        if( !url ) return false;
        return  url.includes('youtube');
    }
    const handleAddExt=(r)=>{
        console.log( r)
        let h = html;
        h+= "\n<br>"+r+"</br>\n.";
        console.log( h )
        setHtml(h);
    }
    const handleAddImage=(url)=>{
        let h = html;
        //h += url;
        if( isYoutube(url)){
            h += "<iframe width='420' height='315' "
                +"src='"+url+"'>"
                +"</iframe>";
        }else if( typeof url === 'object'){
            h +=" <img src='/api/getAnexoById/"+url.idArquivo+"' />"
        }
        else{
            h +=" <img src='"+url+"' />"
        }

        setHtml(h);
    }
    return (
        <BootstrapDialog
            onClose={() => setOpen(false)}
            aria-labelledby="Editor-pagina"
            open={open}
            fullScreen
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="Editor-pagina">
                {montaTitulo()}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Stack>
                    <TextField id="titulo" value={titulo} label="Titulo da pagina" variant="standard" 
                        onChange={(e)=> setTitulo(e.target.value)}
                    />
                {tipo=== 'codigo' && 
                    <div style={{marginTop:10}}>
                        <VeryEditorJS blocks={codigo} setBlocks={setCodigo} />
                    </div>
                }
                {tipo=== 'pagina' && 
                    <VeryEditor2 html={html} ref={ref} 
                        action={
                            <Button autoFocus onClick={handleSalva}>
                                Salvar
                            </Button>
                        }
                />}
                </Stack>

            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleSalva}>
                    Salvar
                </Button>
            </DialogActions>
            <ImgCompDialog open={openImg} setOpen={setOpenImg} action={handleAddImage}/>
            <ExtensionCompDialog open={openExt} setOpen={setOpenExt} action={handleAddExt} />

        </BootstrapDialog>
    )
}